import type { LookupReference } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getMatchFormatsRefData(): Promise<LookupReference[]> {
  return requestApiJsonOrThrow<LookupReference[]>('admin/reference-data/match-formats')
}

export const matchFormatsRefDataQuery = {
  queryKey: ['match-formats-ref-data'],
  queryFn: () => getMatchFormatsRefData(),
}
